import Column from "./default"

export default class TextareaColumn extends Column {
	selectOptions = []
	valueMap = {}

	#icon

	constructor ({ options }) {
		super({ options })
		this.selectOptions = options.options || []
		this.selectOptions.forEach(option => {
			this.valueMap[option.value] = option.label
		})
	}

	onCellEdit (ctx, setValue, notifyCellEditEnd) {
		const textbox = document.createElement("textarea")
		textbox.setAttribute("spellcheck", false)
		textbox.classList.add("textarea")
		textbox.classList.add("hide")
		textbox.style.font = `${ctx.fontSize}pt ${ctx.font}`
		if (this.options.unmodifiableRule(ctx.currentCellInfo.row.data)) {
			textbox.setAttribute("readonly", true)
		}

		const uncover = () => {
			textbox.value = ctx.currentCellInfo.value != null ? ctx.currentCellInfo.value : ""
			textbox.classList.remove("hide")
			Object.entries(this.textboxtCustomEvents(setValue)).forEach(([key, value]) => {
				textbox.addEventListener(key, value)
			})
			// テキスト編集中はグリッドのコピペ処理が動かないようにする
			textbox.addEventListener("copy", e => e.stopPropagation())
			textbox.addEventListener("paste", e => e.stopPropagation())
		}

		textbox.addEventListener("blur", () => {
			notifyCellEditEnd()
			// ここでフォーカスすると、２つ以上グリッドがあった場合にフォーカスの奪い合いになり動作しなくなる
			this.onCellEditEnd(ctx, false)
		}, { once: true })

		textbox.addEventListener("input", e => {
			setValue(e.target.value)
			if (!ctx.isPasting) {
				uncover()
			}
		})

		textbox.addEventListener("click", () => {
			if (this.options.unmodifiableRule(ctx.currentCellInfo.row.data)) return
			uncover()
		}, { once: true })

		textbox.addEventListener("keydown", e => {
			if (this.options.unmodifiableRule(ctx.currentCellInfo.row.data)) return
			const isEnter = e.key === "Enter"
			if (Column.INPUT_END_KEYS.includes(e.key)) {
				if (textbox.classList.contains("hide") && isEnter) {
					uncover()
					return
				}
				if (isEnter && e.altKey) {
					textbox.value += "\r\n"
					e.stopPropagation()
					return
				}
				this.onCellEditEnd(ctx, true)
				this.onCellEdit(ctx, setValue, notifyCellEditEnd)
			} else if (textbox.classList.contains("hide") && e.key === "F2") {
				uncover()
			} else if (!Column.ARROW_KEYS.includes(e.key) && !e.ctrlKey && !e.key === "Delete") {
				if (textbox.classList.contains("hide")) {
					uncover()
				}
			}
		})

		const inputWrapper = ctx.inputEl
		inputWrapper.appendChild(textbox)
		setTimeout(() => {
			textbox.focus()
		})
	}

	renderCell (ctx, {
		offsetTop,
		offsetLeft,
		height,
		value,
		color,
		bgColor,
		cellInfo,
		rowIndex
	}) {
		ctx.useContext2d(ctx2d => {
			// セル描画
			ctx2d.strokeStyle = ctx.gridStyle.borderColor
			ctx2d.lineWidth = ctx.gridStyle.borderLineWidth
			ctx2d.fillStyle = bgColor
			if (cellInfo) {
				ctx2d.fillStyle = cellInfo.bgColor || bgColor || ctx.gridStyle.bgColor
			}
			ctx.fillRect(offsetLeft, offsetTop, this.actualWidth, height)
			ctx.strokeRect(offsetLeft, offsetTop, this.actualWidth, height)
			const text = value != null ? String(value) : ""

			this.renderMultilineTextForCell(ctx, {
				offsetTop,
				offsetLeft,
				height,
				width: this.actualWidth,
				value: text,
				color: cellInfo ? cellInfo.color : color
			})
		})
	}
}
